import { Controller } from "@hotwired/stimulus"
import { showSpinner, showSavedCheck, showError } from "../src/field_status"

// Generyczny checkbox z zapisem do bazy bez wchodzenia w edycję.
// Po zmianie wysyła request (domyślnie PATCH) na `urlValue` z body `{ value: checked }`,
// w trakcie zapisu pokazuje spinner w elemencie `.intum-field-status` (zarezerwowane
// miejsce w partialu — bez przesuwania layoutu). Po sukcesie pokazuje zielony check (znika po 1 s),
// przy błędzie cofa stan checkboxa i pokazuje czerwony krzyżyk.
//
// Endpoint może użyć przesłanego `value` (tryb deklaratywny) albo go zignorować
// i sam przełączyć flagę (tryb toggle) — komponent jest agnostyczny.
//
// Użycie (patrz app/views/components/tailwind/_dynamic_checkbox.html.erb):
//   <div data-controller="dynamic-checkbox"
//        data-dynamic-checkbox-url-value="/form/forms/123/toggle_active"
//        data-dynamic-checkbox-method-value="PATCH">
//     <input type="checkbox" data-action="change->dynamic-checkbox#toggle">
//     <label>...</label>
//     <span class="intum-field-status w-4 h-4"></span>
//   </div>

export default class extends Controller {
  static values = { url: String, method: { type: String, default: "PATCH" } }

  toggle(event) {
    const checked = event.target.checked
    const csrfToken = document.querySelector("meta[name=csrf-token]")
    const spinner = this.element.querySelector(".intum-field-status")

    showSpinner(spinner)

    fetch(this.urlValue, {
      method: this.methodValue,
      headers: {
        "X-CSRF-Token": csrfToken && csrfToken.content,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ value: checked }),
    }).then((response) => {
      if (!response.ok) throw new Error(response.status)
      showSavedCheck(spinner)
    }).catch(() => {
      // zapis się nie powiódł — cofnij stan checkboxa i zasygnalizuj błąd
      event.target.checked = !checked
      showError(spinner)
    })
  }
}
